import * as React from 'react';

import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import { NoteContent } from 'view/layout/note-content';
import { ScreenName } from '@atlassian/help-center-common-component/constants';
import { AnalyticsScreen } from '@atlassian/help-center-common-util/analytics/analytics-screen';
import { CommentSubmitted } from '../comment-submitted';
import { RequestFeedbackForm } from '../request-feedback-form';

interface RequestFeedbackProps {
    isLoading: boolean;
    rating: number;
    commentSubmitting: boolean;
    commentSubmitted: boolean;
    validationErrorType?: string;
    onRatingChange: (rating: number) => void;
    onSaveComment: (comment: string) => void;
    onErrorFlagDismiss: () => void;
    redirectToLogin: boolean;
}

export class RequestFeedbackStateless extends React.Component<RequestFeedbackProps & WrappedComponentProps> {
    render() {
        const {
            isLoading,
            rating,
            onRatingChange,
            onSaveComment,
            commentSubmitted,
            commentSubmitting,
            validationErrorType,
            onErrorFlagDismiss,
            redirectToLogin,
        } = this.props;

        let component;
        if (commentSubmitted) {
            component = (
                <AnalyticsScreen screenName={ScreenName.FEEDBACK_SUBMITTED}>
                    <CommentSubmitted redirectToLogin={redirectToLogin} />
                </AnalyticsScreen>
            );
        } else {
            component = (
                <RequestFeedbackForm
                    rating={rating}
                    onRatingChange={onRatingChange}
                    onSaveComment={onSaveComment}
                    commentSubmitting={commentSubmitting}
                    validationErrorType={validationErrorType}
                    onErrorFlagDismiss={onErrorFlagDismiss}
                />
            );
        }
        return (
            <NoteContent isLoading={isLoading} isCentered>
                <div data-test-id="request-feedback.wrapper">{component}</div>
            </NoteContent>
        );
    }
}

export default injectIntl(RequestFeedbackStateless);
